/*
 * @Author: wsx
 * @Date: 2022-01-24 11:07:35
 * @LastEditTime: 2022-06-15 17:42:49
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:区域
 */
import request from "@/utils/request.js";

const apiUrl = {
  root: {
    list: "/api/hz-smart-community/region/street/tree"
  },
  build: {
    // 楼
    list: "/api/hz-smart-community/region/build/list",
    add: "/api/hz-smart-community/region/build/save",
    update: "/api/hz-smart-community/region/build/update",
    delete: "/api/hz-smart-community/region/build/delete"
  },
  unit: {
    // 单元
    list: "/api/hz-smart-community/region/unit/list",
    add: "/api/hz-smart-community/region/unit/save",
    update: "/api/hz-smart-community/region/unit/update",
    delete: "/api/hz-smart-community/region/unit/delete"
  },
  grid: {
    // 网格
    list: "/api/hz-smart-community/region/grid/list",
    add: "/api/hz-smart-community/region/grid/save",
    update: "/api/hz-smart-community/region/grid/update",
    delete: "/api/hz-smart-community/region/grid/delete"
  },
  plot: {
    // 小区
    list: "/api/hz-smart-community/region/plot/list",
    add: "/api/hz-smart-community/region/plot/save",
    update: "/api/hz-smart-community/region/plot/update",
    delete: "/api/hz-smart-community/region/plot/delete"
  },
  community: {
    // 社区
    list: "/api/hz-smart-community/region/community/list",
    add: "/api/hz-smart-community/region/community/save",
    update: "/api/hz-smart-community/region/community/update",
    delete: "/api/hz-smart-community/region/community/delete"
  },
  street: {
    // 街道
    list: "/api/hz-smart-community/region/street/list",
    add: "/api/hz-smart-community/region/street/save",
    update: "/api/hz-smart-community/region/street/update",
    delete: "/api/hz-smart-community/region/street/delete"
  }
};
// 获取区域列表
export const queryRegionsList = data => {
  const { apiType } = data;
  Reflect.deleteProperty(data, "apiType");
  return request({
    url: apiUrl[apiType || "root"].list,
    params: data || {}
  });
};

// 添加区域
// export const addRegions = data => {
//   const { apiType } = data;
//   Reflect.deleteProperty(data, "apiType");
//   return request({
//     url: apiUrl[apiType].add,
//     data: data || {},
//     method: "POST"
//   });
// };

// // 修改区域
// export const updateRegions = data => {
//   const { apiType } = data;
//   Reflect.deleteProperty(data, "apiType");
//   return request({
//     url: apiUrl[apiType].update,
//     data: data || {},
//     method: "POST"
//   });
// };

// 删除区域
// export const deleteRegions = data => {
//   const { apiType } = data;
//   Reflect.deleteProperty(data, "apiType");
//   return request({
//     url: apiUrl[apiType].delete,
//     data: data || {},
//     method: "POST"
//   });
// };
// 2022-02-14

// 修改门牌号
export const houseinfoupdateRoomNum = data => {
  return request({
    url: "/api/hz-smart-community/house/info/updateRoomNum",
    data: data || {},
    method: "POST"
  });
};

// 获取树的列表
export const getMenutree = data => {
  return request({
    url: "/api/hz-smart-community/region/info/tree",
    params: data || {}
  });
};
// 获取右侧列表
export const leftListquery = data => {
  return request({
    url: "/api/hz-smart-community/region/info/list",
    params: data || {}
  });
};
// 根据id获取区域信息
export const regionSelectids = data => {
  return request({
    url: "/api/hz-smart-community/region/info/selectids",
    data: data || {},
    method: "POST"
  });
};
// 导出
export const regioninfoexport = data => {
  return request({
    url: "/api/hz-smart-community/region/info/export",
    params: data || {},
    responseType: "blob"
  });
};

// 删除
export const regioninfodelete = data => {
  return request({
    url: "/api/hz-smart-community/region/info/delete",
    data: data || {},
    method: "POST"
  });
};

// 详细信息
export const regionInfo = data => {
  return request({
    url: "/api/hz-smart-community/region/info/info/" + data,
    params: data || {}
  });
};

// 添加
export const addRegions = data => {
  return request({
    url: "/api/hz-smart-community/region/info/save",
    data: data || {},
    method: "POST"
  });
};
// 修改
export const updateRegions = data => {
  return request({
    url: "/api/hz-smart-community/region/info/update",
    data: data || {},
    method: "POST"
  });
};
// 删除
export const deleteRegions = data => {
  return request({
    url: "/api/hz-smart-community/region/street/delete",
    data: data || {},
    method: "POST"
  });
};
// 获取区域数据（排序用）
export const infoByParentId = data => {
  return request({
    url: "/api/hz-smart-community/region/info/infoByParentId",
    params: data || {},
    method: "get"
  });
};
// 更新区域数据（排序用）
export const updateSeq = data => {
  return request({
    url: "/api/hz-smart-community/region/info/update/seq",
    data: data || {},
    method: "POST"
  });
};
// 门牌号管理
export const listByRegionId = data => {
  return request({
    url: "/api/hz-smart-community/house/info/listByRegionId",
    params: data || {}
  });
};

// 摄像机区域关联
export const areaRelation = data => {
  return request({
    url: "/api/hz-data-community/resources_tree_area/relation",
    data: data || {},
    method: "post"
  });
};
// 摄像机区域关联
export const areaRelationData = data => {
  return request({
    url: "/apiData/hz-data-community/resources_tree_area/relation",
    data: data || {},
    method: "post"
  });
};

// 导入(人口)
export const uploading = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/import",
    data: data || {},
    method: "post",
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// 下载模板(人口)
export const downloading = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/import/file",
    responseType: "blob",
    method: "get"
  });
};

// 导出(人口)
export const deriveing = data => {
  return request({
    url: "/api/hz-smart-community/prison/info/export",
    params: data || {},
    responseType: "blob"
  });
};

// 导出(房屋)
export const derivehouse = data => {
  return request({
    url: "/api/hz-smart-community/house/info/export",
    params: data || {},
    responseType: "blob"
  });
};

// 导入(单位)
export const uploadunit = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/import",
    data: data || {},
    method: "post",
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// 导出(单位)
export const deriveunit = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/export",
    params: data || {},
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob"
  });
};

// 下载模板(单位)
export const downloadunit = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/import/file",
    responseType: "blob",
    method: "get"
  });
};

// 导入(物业)
export const uploadreal = data => {
  return request({
    url: "/api/hz-smart-community/property/info/import",
    data: data || {},
    method: "post",
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// 导出(物业)
export const derivereal = data => {
  return request({
    url: "/api/hz-smart-community/property/info/export",
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob",
    params: data || {}
  });
};

// 下载模板(物业)
export const downloadreal = data => {
  return request({
    url: "/api/hz-smart-community/property/info/import/file",
    responseType: "blob",
    method: "get"
  });
};
// ---

// 导入(车辆)
export const uploadcar = data => {
  return request({
    url: "/api/hz-smart-community/car/info/import",
    data: data || {},
    method: "post",
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// 导出(车辆)
export const derivecar = data => {
  return request({
    url: "/api/hz-smart-community/car/info/export",
    params: data || {},
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob"
  });
};

// 下载模板(车辆)
export const downloadcar = data => {
  return request({
    url: "/api/hz-smart-community/car/info/import/file",
    responseType: "blob",
    method: "get"
  });
};

// --
// 导入(安防)
export const uploadsecurity = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/import",
    data: data || {},
    method: "post",
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// 导出(安防)
export const derivesecurity = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/export",
    params: data || {},
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob"
  });
};

// 下载模板(安防)
export const downloadsecurity = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/import/file",
    responseType: "blob",
    method: "get"
  });
};

// --
// 导入(实有力量)
export const uploadpower = data => {
  return request({
    url: "/api/hz-smart-community/strength/info/import",
    data: data || {},
    method: "post",
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// 导出(实有力量)
export const derivepower = data => {
  return request({
    url: "/api/hz-smart-community/strength/info/export",
    params: data || {},
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "blob"
  });
};

// 下载模板(实有力量)
export const downloadpower = data => {
  return request({
    url: "/api/hz-smart-community/strength/info/import/file",
    responseType: "blob",
    method: "get"
  });
};
// --
// 导入(实有装备)
export const uploadequip = data => {
  return request({
    url: "/api/hz-smart-community/equipment/info/import",
    data: data || {},
    method: "post",
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// 导出(实有装备)
export const deriveequip = data => {
  return request({
    url: "/api/hz-smart-community/equipment/info/export",
    params: data || {},
    responseType: "blob",
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 下载模板(实有装备)
export const downloadequip = data => {
  return request({
    url: "/api/hz-smart-community/equipment/info/import/file",
    responseType: "blob",
    method: "get"
  });
};
// --

// 导入(组织管理)
export const uploaddept = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/import",
    data: data || {},
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 导出(组织管理)
export const derivedept = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/export",
    responseType: "blob",
    params: data || {},
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 下载模板(组织管理)
export const downloaddept = data => {
  return request({
    url: "/api/hz-smart-community/sys/dept/import/file",
    responseType: "blob",
    method: "get"
  });
};
// --

// 导入(用户管理)
export const uploaduser = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/import",
    data: data || {},
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 导出(用户管理)
export const deriveuser = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/export",
    responseType: "blob",
    params: data || {},
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 下载模板(用户管理)
export const downloaduser = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/import/file",
    responseType: "blob",
    method: "get"
  });
};

// --

// 导入(水电燃气)
export const uploadweg = data => {
  return request({
    url: "/api/hz-smart-community/house/weg/import",
    data: data || {},
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 下载模板(水电燃气)
export const downloadweg = data => {
  return request({
    url: "/api/hz-smart-community/house/weg/import/file",
    responseType: "blob",
    method: "get"
  });
};
// 区域下载模板
export const importfile = data => {
  return request({
    url: "/api/hz-smart-community/region/info/import/file",
    responseType: "blob",
    method: "get"
  });
};
// 模板下载
export const infoimport = data => {
  return request({
    url: "/api/hz-smart-community/region/info/import",
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
    method: 'POST'
  });
};